import { render, staticRenderFns } from "./Amenities.vue?vue&type=template&id=a0ab1194&scoped=true"
import script from "./Amenities.vue?vue&type=script&lang=js"
export * from "./Amenities.vue?vue&type=script&lang=js"
import style0 from "./Amenities.vue?vue&type=style&index=0&id=a0ab1194&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ab1194",
  null
  
)

export default component.exports